var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"messenger-app-title",attrs:{"row":""}},[_c('v-flex',{staticClass:"messenger-app-title__label"},[_vm._t("title"),_vm._t("preview")],2),_c('v-flex',{staticClass:"text-right"},[_vm._t("actions")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }